import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ui-popover',
	templateUrl: './popover.component.html',
	styleUrls: ['./popover.component.less'],
})
export class UIPopoverComponent implements OnChanges {
	@Input() placement: string = 'top center';
	@Input() show: boolean = false;
	@Input() minWidth: number = 32;
	@Input() minHeight: number = 32;
	@Input() maxWidth: number = 10000;
	@Input() maxHeight: number = 10000;
	@Input() showArrow: boolean = true;
	@Input() hasBackdrop: boolean = false;

	@Output() hidden: EventEmitter<null> = new EventEmitter<null>();

	popoverPlacement: string[] = ['top', 'center'];

	ngOnChanges(): void {
		this.popoverPlacement = this.placement.split(' ');
	}

	onBackdropClicked(): void {
		this.hidden.emit();
	}
}
